export default __webpack_public_path__ + "0472d9dea8d2cb67b778df50bf682beb.svg";